import React, { useEffect, useState } from "react";
import "./privacypage.css";
import SNavbar from "../../components/SNavbar";
import { LeftArrow } from "./../../assets/SvgIcons";
import PrivacySkelton from "../skelton/PrivacySkelton";

const PrivacyPage = () => {
  const privacyData = [
    {
      titple: "1. Збір інформації",
      info: "Ми можемо збирати різноманітну інформацію, включаючи, але не обмежуючись, особисті дані, контактні дані, дані про пристрій, інформацію про використання послуг і більше. Ця інформація дозволяє нам покращити ваш досвід та надавати вам персоналізовану обслуговуваність.",
    },
    {
      titple: "2. Використання інформації",
      info: "Ми використовуємо зібрану інформацію для надання послуг, взаємодії з вами, вдосконалення продуктів та аналізу використання. Ми дотримуємося прозорих цілей і надаємо можливість вибору в тому, як ви хочете, щоб ваші дані використовувалися.",
    },
    {
      titple: "3. Розкриття інформації третім особам",
      info: "Ми можемо передавати інформацію третім особам за вашим дозволом або у випадках, передбачених законодавством. Ми забезпечуємо, що треті сторони також дотримуються високих стандартів конфіденційності.",
    },
    {
      titple: "4. Захист інформації",
      info: "Ми можемо передавати інформацію третім особам за вашим дозволом або у випадках, передбачених законодавством. Ми забезпечуємо, що треті сторони також дотримуються високих стандартів конфіденційності.",
    },
    {
      titple: "5. Захист інформації",
      info: "Ми можемо передавати інформацію третім особам за вашим дозволом або у випадках, передбачених законодавством. Ми забезпечуємо, що треті сторони також дотримуються високих стандартів конфіденційності.",
    },
    {
      titple: "6. Захист інформації",
      info: "Ми можемо передавати інформацію третім особам за вашим дозволом або у випадках, передбачених законодавством. Ми забезпечуємо, що треті сторони також дотримуються високих стандартів конфіденційності.",
    },
  ];

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);
  if (loading) {
    return <PrivacySkelton />;
  }
  return (
    <div className="privacy-page-container">
      <SNavbar
        actionBTN={<LeftArrow />}
        title={"Політика конфіденційності"}
        path={"/"}
      />
      <div className="privacy-wrapper ">
        <div className="privacy-wrapper-container  " id="privacy">
          <div className="privacy-header">
            <h1>Політика конфіденційності</h1>
            <p>
              Дата набрання чинності: <span> 17 січня 2023 р</span>
            </p>
          </div>
          <p className="privacy-info">
            Вітаємо в Roger Studio! <br /> <br />
            Ця політика конфіденційності визначає, як ми збираємо,
            використовуємо, передаємо та захищаємо інформацію, яку ви нам
            надаєте під час використання наших продуктів та послуг.
          </p>
          {privacyData.map((item, index) => (
            <div className="privacy-info-content">
              <h3>{item.titple}</h3>
              <p>{item.info}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
